import { useMediaQuery } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Edit, Loading, NumberInput, required, SelectInput, SimpleForm, TextInput, useNotify,useEditController } from 'react-admin';
import { devises, getAgentListByRole, getAgentRole, has_role, json, modePayement,getUserRoles } from '../references.js';

const  EditVersement =(props,...rest) => {
    const notify = useNotify();
    const [fullname, setFullname] = useState('');

    const [listUserByRole, setListUserByRole] = useState();
    const [disabledSaveButton, setDisabledSaveButton] = useState(true);
    const [defaultValues, setDefaultValues] = useState();

    const [role, setRole] = useState(null);
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const { permissions } = props;

    const { record } = useEditController(props);


   useEffect(() => {
     //console.log(record);
       
       // setFullname(localStorage.getItem('fullname'));
        //setRole('ROLE_MANAGER');
        
      
         
        //let userRole=null;
        
        fetch(process.env.REACT_APP_URL+'/user/getUserByRoles', 
          {     method: 'GET',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        "Authorization": "Bearer "+ localStorage.getItem('token')
                }
            }
        ).then(json)
        .then((data) => {
            if(data.error){
                notify(data.message, 'warning');
                setListUserByRole([]);
            }  
            else{
              
              //console.log(userRole);
              setListUserByRole(data);
            } 
            
            //console.log(data);
            //setListUserByRole(data);
        }).catch((e) => {
            notify("Erreur lors du processus de récupération de la liste des agents !", 'warning')
        });

        //if(record && record.user_rec_id) userRole=;


      
    }, []);

    var valInitiales;
    if(record && record.user_rec_id && listUserByRole ){
        
      valInitiales={
        "user_rec_id":record.user_rec_id,
        "type":getUserRoles(listUserByRole,record.user_rec_id)
       
      };
      //setDefaultValues(valInitiales);
      console.log(valInitiales);
    }
    

    //console.log(getAgentRole(listUserByRole))
    //console.log(defaultValues);
  
    const typeChange=(event)=>{
        setRole(event.target.value);
    }
    
  return (
     
    
   ( !listUserByRole)  ? <Loading /> : 

      <Edit {...props}  title={'Création VST - '+localStorage.getItem('fullname')}  >
        <SimpleForm  {...props}  submitOnEnter={true}  redirect="show" margin="none"  initialValues={valInitiales}>
        {
         has_role(permissions,'ROLE_MANAGER')  ?   
            <>  
            { isSmall ?
          <SelectInput {...rest} fullWidth source="mode_vst" label="Mode versement" validate={required()} choices={modePayement}  />:
          <SelectInput {...rest} style={{width:'50%'}} source="mode_vst" label="Mode versement" validate={required()} choices={modePayement} />
            }
          </>
            
        : <TextInput  style={{display:'none'}} source="mode_vst"  defaultValue="espece" />
        }
            
          { isSmall ?
              <SelectInput {...rest} fullWidth source="type" label="Type agent" validate={required()} choices={getAgentRole(listUserByRole)} onChange={(event)=>typeChange(event)} />
              :
              <SelectInput {...rest} style={{width:'50%'}} source="type" label="Type agent"  validate={required()} choices={getAgentRole(listUserByRole)} onChange={(event)=>typeChange(event)}  />
          } 
         { isSmall ?
              <SelectInput {...rest} fullWidth source="user_rec_id" label="Agent" validate={required()} choices={role===null?getAgentListByRole(valInitiales.type,listUserByRole):getAgentListByRole(role,listUserByRole)}  />
              :
              <SelectInput {...rest} style={{width:'50%'}} source="user_rec_id" label="Agent" validate={required()} choices={role===null?getAgentListByRole(valInitiales.type,listUserByRole):getAgentListByRole(role,listUserByRole)} />
          }  

        { isSmall ?
              <SelectInput {...rest} fullWidth source="devise" label="Devise" validate={required()} choices={devises}  />
              :
              <SelectInput {...rest} style={{width:'50%'}} source="devise" label="Devise" validate={required()} choices={devises} />
          }

        { isSmall ?
              <NumberInput {...rest} fullWidth source="montant" label="Montant"  validate={required()}/>
              :
              <NumberInput {...rest} style={{width:'50%'}} source="montant" label="Montant" validate={required()}  />
          }

        { isSmall ?
              <TextInput {...rest} fullWidth source="commentaire" label="Commentaire"  />
              :
              <TextInput {...rest} style={{width:'50%'}} source="commentaire" label="Commentaire"   />
          }
        
        </SimpleForm>
    </Edit> 
    );
};

export default EditVersement;
